import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewRecord from "@/pages/NewRecord";
import MyDeals from "@/pages/MyDeals";
import DealForm from "@/pages/DealForm";
import DealDetail from "@/pages/DealDetail";
import Agenda from "@/pages/Agenda";
import Statistics from "@/pages/Statistics";
import AdminTracking from "@/pages/AdminTracking";
import Report from "@/pages/Report";
import CRM from "@/pages/CRM";
import LeadDetail from "@/pages/LeadDetail";
import CRMSettings from "@/pages/CRMSettings";
import CRMForms from "@/pages/CRMForms";
import CourseLeads from "@/pages/CourseLeads";
import CRMDashboard from "@/pages/CRMDashboard";
import FinanceModule from "@/pages/FinanceModule";
import ExternalLinks from "@/pages/ExternalLinks";
import InmueblesDrive from "@/pages/InmueblesDrive";
import PrivacyConsents from "@/pages/PrivacyConsents";
import SheetSyncs from "@/pages/SheetSyncs";
import WasiSync from "@/pages/WasiSync";
import UserSettings from "@/pages/UserSettings";
import MetaCRM from "@/pages/MetaCRM";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#03110D]"><div className="animate-pulse font-outfit text-2xl text-[#A38560]">SELECTO CRM</div></div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-[#03110D]"><div className="animate-pulse font-outfit text-2xl text-[#A38560]">SELECTO CRM</div></div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'deeplook' ? '/crm-dashboard' : '/'} /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={user?.role === 'deeplook' ? <Navigate to="/crm-dashboard" /> : <Dashboard />} />
        <Route path="nuevo" element={<NewRecord />} />
        <Route path="negocios" element={<MyDeals />} />
        <Route path="negocios/crear" element={<DealForm />} />
        <Route path="negocios/:id" element={<DealDetail />} />
        <Route path="estadisticas" element={<Statistics />} />
        <Route path="seguimiento" element={<AdminTracking />} />
        <Route path="reporte" element={<Report />} />
        <Route path="crm" element={<CRM />} />
        <Route path="crm-dashboard" element={<CRMDashboard />} />
        <Route path="crm/:id" element={<LeadDetail />} />
        <Route path="crm-config" element={<CRMSettings />} />
        <Route path="meta" element={<MetaCRM />} />
        <Route path="formularios" element={<CRMForms />} />
        <Route path="leads-curso" element={<CourseLeads />} />
        <Route path="usuarios" element={<UserSettings />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="finanzas" element={<FinanceModule />} />
        <Route path="links" element={<ExternalLinks />} />
        <Route path="inmuebles" element={<InmueblesDrive />} />
        <Route path="habeas-data" element={<PrivacyConsents />} />
        <Route path="sheet-syncs" element={<SheetSyncs />} />
        <Route path="wasi" element={<WasiSync />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
